import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "./App.css";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import AdminProtected from "./components/AdminProtected";

const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Careers = lazy(() => import("./pages/Careers"));
const Locations = lazy(() => import("./pages/Locations"));
const ProvincePage = lazy(() => import("./pages/ProvincePage"));
const CityPage = lazy(() => import("./pages/CityPage"));
const ServicesIndex = lazy(() => import("./pages/ServicesIndex"));
const ServiceDetail = lazy(() => import("./pages/ServiceDetail"));
const HomeCareAgency = lazy(() => import("./pages/HomeCareAgency"));
const StaffingAgency = lazy(() => import("./pages/StaffingAgency"));
const BlogIndex = lazy(() => import("./pages/BlogIndex"));
const BlogArticle = lazy(() => import("./pages/BlogArticle"));
const NotFound = lazy(() => import("./pages/NotFound"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));

function PageFallback() {
  return (
    <div className="min-h-[60vh] flex items-center px-6" data-testid="page-loader">
      <div className="h-[1px] w-40 bg-ink/20 loader-line" />
    </div>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            {/* Admin routes — no Nav/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <AdminProtected>
                  <AdminDashboard />
                </AdminProtected>
              }
            />

            {/* Public site with Layout */}
            <Route
              path="*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/careers" element={<Careers />} />
                    <Route path="/locations" element={<Locations />} />
                    <Route path="/locations/:province" element={<ProvincePage />} />
                    <Route path="/locations/:province/:city" element={<CityPage />} />
                    <Route path="/services" element={<ServicesIndex />} />
                    <Route path="/services/:slug" element={<ServiceDetail />} />
                    <Route path="/home-care-agency" element={<HomeCareAgency />} />
                    <Route path="/healthcare-staffing" element={<StaffingAgency />} />
                    <Route path="/blog" element={<BlogIndex />} />
                    <Route path="/blog/:slug" element={<BlogArticle />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </Suspense>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0A2E25",
              color: "#FAF9F6",
              border: "none",
              borderRadius: 0,
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </HelmetProvider>
  );
}
